export default __webpack_public_path__ + "static/media/logo.b3188b17.png";